import SmallNumberBox from './SmallNumberBox'

type EmployeesBoxProps = {
  animationProps: any
  title: string
  titleColor?: string
  backgroundColor?: string
  borderColor?: string
}

const EmployeesBox = ({
  animationProps,
  title,
  titleColor = '#266782',
  backgroundColor = '#FFF166',
  borderColor = '#266782',
  children,
}: React.PropsWithChildren<EmployeesBoxProps>) => {
  return (
    <SmallNumberBox
      animationProps={animationProps}
      title={title}
      titleColor={titleColor}
      backgroundColor={backgroundColor}
      borderColor={borderColor}
    >
      <span className="text-9xl font-medium">{children}</span>
    </SmallNumberBox>
  )
}

export default EmployeesBox
